export const fullscreenLoadingMessages = {
  loaderContext: {
    title: 'Preparando seu acesso ao app ! 📱 ✨',
    subtitle: 'Validando dados, preparando as informações, estabelecendo conexões e garantindo integridade da aplicação.Aguarde... Isso pode levar alguns instantes.',
  },
  routeSuspense: {
    title: 'Verificando seu acesso ao app ! 📱 ✨',
    subtitle: 'Carregando conteúdo da tela ...',
  },
  protectedRoute: {
    title: 'Verificando integridade ! 📱 ✨',
    subtitle: 'Aguarde... Isso pode levar alguns instantes.',
  },
  signIn: {
    validatingCredentials: 'Validando suas credenciais...',
    slowServer: 'Estabelecendo acessos! Aguarde...',
    loadingAccount: 'Carregando conteúdo da sua conta...',
    loadingAppContent: 'Carregando conteúdo inicial do aplicativo...',
    syncingData: 'Sincronizando dados essenciais...',
    finishing: 'Finalizando seu acesso...',
  },
} as const;
